import request from "../utils/request";

export function login(query) {
  return request({
    url: "/login",
    method: "post",
    data: query,
  });
}

export function updateUserFromApproval(query) {
  return request({
    url: "/updateUserFromApproval",
    method: "post",
    data: query,
  });
}

export function updateUserFromWeb(query) {
  return request({
    url: "/updateUserFromWeb",
    method: "post",
    data: query,
  });
}

export function register(data) {
  return request({
    url: "/register",
    method: "post",
    data: data,
  });
}

export function getUser(userId) {
  return request({
    url: "/getUser/" + userId,
    method: "get",
  });
}

export function getAllProInfoByAuthFlg(authFlg) {
  return request({
    url: "/getAllProInfoByAuthFlg/" + authFlg,
    method: "get",
  });
}

export function verify(token) {
  return request({
    url: "/verify/" + token,
    method: "get",
  });
}

export function getDaikaiParticipants() {
  return request({
    url: "/getDaikaiParticipants",
    method: "get",
  });
}
export function getUserFans() {
  return request({
    url: "/getUserFans",
    method: "get",
  });
}
export function getWebUserSchedule() {
  return request({
    url: "/getWebUserSchedule",
    method: "get",
  });
}
// 推しごとカレンダー、雀活マスター利用人数を統計
export function getOshicalAndJankatsumasterUserCnt() {
  return request({
    url: "/getOshicalAndJankatsumasterUserCnt",
    method: "get",
  });
}

// 広告集計
export function getADDisplayInfoSUMList() {
  return request({
    url: "/getADDisplayInfoSUMList",
    method: "get",
  });
}
// 広告一覧
export function getADDisplayInfoList() {
  return request({
    url: "/getADDisplayInfoList",
    method: "get",
  });
}
// 広告ダッシュボード(時間単位)
export function getADPerTimeInfoList(query) {
  return request({
    url: "/getADPerTimeInfoList",
    method: "post",
    data: query,
  });
}
// 広告ダッシュボード(日単位)
export function getADPerDayInfoList(query) {
  return request({
    url: "/getADPerDayInfoList",
    method: "post",
    data: query,
  });
}
// ゲスト(日単位)
export function getGuestPerDayInfoList(query) {
  return request({
    url: "/getGuestPerDayInfoList",
    method: "post",
    data: query,
  });
}
// 広告ダッシュボード(週単位)
export function getADPerWeekInfoList(query) {
  return request({
    url: "/getADPerWeekInfoList",
    method: "post",
    data: query,
  });
}
// 広告集計情報
export function getSumADInfo(query) {
  return request({
    url: "/getSumADInfo",
    method: "post",
    data: query,
  });
}

// 広告集計情報(指定期間以降の合計)
export function getSumADInfoFrom(query) {
  query.startDate = "2026/01/01/ 00:00:00";
  return request({
    url: "/getSumADInfoFrom",
    method: "post",
    data: query,
  });
}

// 広告集計情報
export function getAllADListForUser(query) {
  return request({
    url: "/getAllADListForUser",
    method: "post",
    data: query,
  });
}
